import * as React from "react";
import { useDispatch } from "react-redux";

import {
  destroyPatchForm,
  constants,
  update,
  useParkingContractForm,
} from "../../../../store/parkingContracts";
import { updateActiveFormInstance } from "../../../../store/base";
import { cloneDeep } from "lodash";

import Modal from "../../Base/Modals/Modal";
import OverlaySpinner from "src/components/Loaders/OverlaySpinner";
import TenantTable from "src/components/Tables/Tenants/FullTableNewVersion";
import TableSelectFieldWithCreate from "../../Base/Fields/TableSelectFieldWithCreate";
import TenantNestedChildren from "../../Tenant/NestedChildren";

export default function UpdateParkingContractTenantModalForm({
  id,
  onCheckout,
  instance = {},
}) {
  const method = "PATCH"; // always patch
  const dispatch = useDispatch();
  const storeName = constants.STORE_NAME;
  const [loading, setLoading] = React.useState(false);

  const formLoaded = Boolean(useParkingContractForm(method, id));

  const preProcess = (data) => {
    const clone = cloneDeep(data);

    if (!clone.tenant) {
      clone.tenant = null;
    }

    return clone;
  };

  React.useEffect(() => {
    if (instance) {
      dispatch(
        updateActiveFormInstance({
          storeName: storeName,
          data: instance,
        })
      );
    }
  }, []);

  const checkout = (success) => {
    dispatch(destroyPatchForm(success));

    onCheckout();
  };

  const onSuccess = (_, returned) => {
    setLoading(false);
    checkout(true);
  };

  const onSubmit = () => {
    setLoading(true);

    dispatch(
      update({
        preProcess,
        id,
        successCallback: onSuccess,
        errorCallback: () => setLoading(false),
      })
    );
  };

  const onDone = () => {
    checkout(false);
  };

  return (
    <Modal
      title="Uppdatera avtal"
      closeFunction={onDone}
      onAccept={onSubmit}
      acceptTitle="Spara"
    >
      {(loading || !formLoaded) && <OverlaySpinner />}

      <div className="grid grid-cols-2 gap-6 mb-6">
        <TableSelectFieldWithCreate
          storeName={storeName}
          fieldKey="tenant"
          method={method}
          placeholder="Välj hyresgäst..."
          title="Hyresgäst"
          description="Den huvudsakliga hyresgästen. Denna hyresgäst är även mottagare av avier för avtalet om avisering är aktiverat."
          TableComponent={TenantTable}
          createDisplayKey="user.first_name"
        >
          {(parentPath) => (
            <TenantNestedChildren
              storeName={storeName}
              method={method}
              parentInstructionsPath={"tenant"}
              parentPath={parentPath}
            />
          )}
        </TableSelectFieldWithCreate>
      </div>
    </Modal>
  );
}
